export default __webpack_public_path__ + "static/media/image13.e7f7767f.jpg";